import { BoxProps } from "@mui/material";
import { forwardRef } from "react";

export type MDBoxProps = BoxProps & {
  variant?: "contained" | "gradient";
  bgColor?:
    | "transparent"
    | "white"
    | "black"
    | "primary"
    | "secondary"
    | "info"
    | "success"
    | "warning"
    | "error"
    | "light"
    | "dark"
    | "text"
    | "grey-100"
    | "grey-200"
    | "grey-300"
    | "grey-400"
    | "grey-500"
    | "grey-600"
    | "grey-700"
    | "grey-800"
    | "grey-900";
  color?:
    | "transparent"
    | "white"
    | "black"
    | "primary"
    | "secondary"
    | "info"
    | "success"
    | "warning"
    | "error"
    | "light"
    | "dark"
    | "text"
    | "grey-100"
    | "grey-200"
    | "grey-300"
    | "grey-400"
    | "grey-500"
    | "grey-600"
    | "grey-700"
    | "grey-800"
    | "grey-900"
    | "inherit";
  opacity?: number;
  borderRadius?: "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "section";
  shadow?: "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "inset";
  coloredShadow?:
    | "primary"
    | "secondary"
    | "info"
    | "success"
    | "warning"
    | "error"
    | "light"
    | "dark"
    | "none";
  src?: string;
  alt?: string;
  component?: React.ElementType;
};

import MDBoxRoot from "./MDBoxRoot";

const MDBox = forwardRef<HTMLDivElement, MDBoxProps>(
  (
    {
      variant = "contained",
      bgColor = "transparent",
      color = "dark",
      opacity = 1,
      borderRadius,
      shadow,
      coloredShadow = "none",
      src,
      alt,
      component = "div",
      ...rest
    },
    ref
  ) => (
    <MDBoxRoot
      {...rest}
      component={component}
      src={component === "img" ? src : undefined}
      alt={component === "img" ? alt : undefined}
      ref={ref}
      ownerState={{
        variant,
        bgColor,
        color,
        opacity,
        borderRadius,
        shadow,
        coloredShadow,
      }}
    />
  )
);

MDBox.displayName = "MDBox";
export default MDBox;
